module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/router-283.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/router.md
// module id = 726
// module chunks = 404